<template>
  <div>
    <v-data-table
      class="elevation-1"
      :headers="cabeceras"
      :items="documentos"
      :loading="cargando"
      :server-items-length="totalItems"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100, 200],
      }"
      :item-class="(item) => (item.eliminadoEn != null ? 'bg-eliminado' : '')"
      dense
      @update:page="$emit('cargar-datos')"
      @update:items-per-page="$emit('actualizar-items-por-pagina', $event)">
      <template v-slot:[`item.estudiante`]="{ item }">
        <v-list class="py-0" color="transparent" dense two-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title>
                {{
                  concatenar(
                    item.inscripcion.estudiante.nombres,
                    item.inscripcion.estudiante.primerApellido,
                    item.inscripcion.estudiante.segundoApellido,
                  )
                }}
              </v-list-item-title>

              <v-list-item-subtitle> {{ item.inscripcion.estudiante.numeroDocumento }} </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.tipoDocumentoPersona`]="{ item }">
        <v-list class="py-0" color="transparent" dense two-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title>{{ item.documentoPersona.tipoDocumentoPersona.nombre }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ propositosTiposDocumentosPersonaTextos[item.documentoPersona.tipoDocumentoPersona.proposito] }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.fechaVencimiento`]="{ item }">
        <v-list class="py-0" color="transparent" dense two-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title v-if="item.documentoPersona.tipoDocumentoPersona.aplicaFechaVencimiento">
                {{ item.documentoPersona.esIndefinido ? 'Indefinido' : item.documentoPersona.fechaVencimiento }}
              </v-list-item-title>

              <v-list-item-title v-else>-</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.fechaRemplazo`]="{ item }">
        <v-list class="py-0" color="transparent" dense two-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title>
                {{ formatearFecha(item.eliminadoEn) || '-' }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.programa`]="{ item }">
        <v-list class="py-0" color="transparent" dense three-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title>{{ item.inscripcion.programa.nombreCompuesto }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ `${item.inscripcion.programa.codigo} (ID.: ${item.inscripcion.programa.id})` }}
              </v-list-item-subtitle>
              <v-list-item-subtitle> {{ item.inscripcion.programa.sede.nombre }} </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.programaUniversidad`]="{ item }">
        <v-list class="py-0" color="transparent" dense three-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.inscripcion.programa?.programaUniversidad?.programaNombre || '-' }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ item.inscripcion.programa?.programaUniversidad?.codigo || '-' }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ item.inscripcion.programa?.programaUniversidad?.sedeUniversidad?.nombre || '-' }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.subido`]="{ item }">
        <v-list class="py-0" color="transparent" dense two-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title>{{ item.documentoPersona.subidoPor }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ formatearFecha(item.documentoPersona.creadoEn) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.revisado`]="{ item }">
        <v-list class="py-0" color="transparent" dense two-line>
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <v-list-item-title>
                {{
                  item.documentoPersona.tipoDocumentoPersona.requiereValidacion
                    ? item.documentoPersona.revisadoPor || '-'
                    : 'N/A'
                }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{
                  item.documentoPersona.tipoDocumentoPersona.requiereValidacion
                    ? item.documentoPersona.fechaHoraRevision
                      ? formatearFecha(item.documentoPersona.fechaHoraRevision)
                      : '-'
                    : 'N/A'
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:[`item.acciones`]="{ item }">
        <div class="d-flex flex-wrap align-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                v-bind="attrs"
                v-on="on"
                icon
                small
                color="primary"
                @click="$router.push({ name: 'documentos-inscripciones-ver', params: { id: item.id } })">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </template>

            <span>Ver Detalle</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                v-bind="attrs"
                v-on="on"
                icon
                small
                color="primary"
                @click="$refs.modalPrevisualizacionRef.abrir(item.id)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>

            <span>Previsualizar</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:[`item.documentoPersona.tipoDocumentoPersona.requiereValidacion`]="{ item }">
        <v-chip
          :color="getRequireValidacionColor(item.documentoPersona.tipoDocumentoPersona.requiereValidacion)"
          small
          dark>
          {{ item.documentoPersona.tipoDocumentoPersona.requiereValidacion ? 'Sí' : 'No' }}
        </v-chip>
      </template>

      <template v-slot:[`item.documentoPersona.estadoRevision`]="{ item }">
        <v-chip
          v-if="item.documentoPersona.tipoDocumentoPersona.requiereValidacion"
          :color="getEstadoRevisionColor(item.documentoPersona.estadoRevision)"
          small
          dark>
          {{ item.documentoPersona.estadoRevision }}
        </v-chip>

        <span style="font-size: 13px" v-else>N/A</span>
      </template>

      <template v-slot:[`item.documentoPersona.creadoEn`]="{ item }">
        {{ formatearFecha(item.documentoPersona.creadoEn) }}
      </template>

      <template v-slot:[`item.documentoPersona.observaciones`]="{ item }">
        <p class="text-caption">{{ item.documentoPersona.observaciones || '-' }}</p>
      </template>
    </v-data-table>

    <ModalPrevisualizacion ref="modalPrevisualizacionRef" />
  </div>
</template>

<script>
import { PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS } from '../../../comisiones/utils/constantes';
import ModalPrevisualizacion from './ModalPrevisualizacion.vue';

export default {
  name: 'DataTableDocumentosInscripciones',
  components: {
    ModalPrevisualizacion,
  },
  props: {
    documentos: {
      type: Array,
      required: true,
    },
    cargando: {
      type: Boolean,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    itemsPorPagina: {
      type: Number,
      required: true,
    },
    pagina: {
      type: Number,
      required: true,
    },
  },
  computed: {
    page: {
      get() {
        return this.pagina;
      },
      set(value) {
        this.$emit('update:pagina', value);
      },
    },
    itemsPerPage: {
      get() {
        return this.itemsPorPagina;
      },
      set(value) {
        this.$emit('update:itemsPorPagina', value);
      },
    },
  },
  data() {
    return {
      cabeceras: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Acciones', value: 'acciones', sortable: false, width: 140 },
        { text: 'Estudiante', value: 'estudiante', sortable: false, width: 300 },
        { text: 'Tipo Documento', value: 'tipoDocumentoPersona', sortable: false, width: 200 },
        {
          text: 'Requiere Validación',
          value: 'documentoPersona.tipoDocumentoPersona.requiereValidacion',
          sortable: false,
        },
        { text: 'Estado Revisión', value: 'documentoPersona.estadoRevision', sortable: false },
        { text: 'Fecha de Remplazo', value: 'fechaRemplazo', sortable: false, width: 120 },
        { text: 'Fecha de Vencimiento', value: 'fechaVencimiento', sortable: false, width: 120 },
        { text: 'Programa', value: 'programa', sortable: false },
        { text: 'Categoría', value: 'inscripcion.programa.postgrado.categoria.nombre', sortable: false },
        { text: 'Programa Universidad', value: 'programaUniversidad', sortable: false },
        { text: 'Subido Por / Subido En', value: 'subido', sortable: false, width: 300 },
        { text: 'Revisado Por / Revisado En', value: 'revisado', sortable: false, width: 300 },
        { text: 'Observaciones', value: 'documentoPersona.observaciones', sortable: false, width: 300 },
      ],
      propositosTiposDocumentosPersonaTextos: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS,
    };
  },
  methods: {
    getEstadoRevisionColor(estado) {
      const colores = {
        pendiente: 'orange',
        aprobado: 'success',
        rechazado: 'error',
      };

      return colores[estado] || 'grey';
    },
    getRequireValidacionColor(requiereValidacion) {
      return requiereValidacion ? 'green' : 'red';
    },
    formatearFecha(fecha) {
      if (!fecha) {
        return '';
      }

      return new Date(fecha).toLocaleString('es-BO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    concatenar(...args) {
      return args.filter((arg) => arg).join(' ');
    },
  },
};
</script>

<style>
.bg-eliminado {
  background-color: #ffebee !important;
}
</style>